var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-image-component",
      class: { "overflow-hidden": !_vm.overflow },
    },
    [
      _c(
        "div",
        {
          ref: "bg-image-wrapper",
          staticClass: "bg-image-wrapper",
          class: {
            loaded: _vm.loaded,
            blur: _vm.placeholder,
            height: _vm.effect ? _vm.effect.type === "height" : false,
          },
          style: { backgroundColor: _vm.bgColor },
        },
        [
          _vm.placeholder
            ? _c("div", {
                ref: "bg-placeholder",
                staticClass: "bg-image bg-image-low",
                style: {
                  backgroundImage: "url(" + _vm.placeholder + ")",
                  opacity: _vm.opacity,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.lazyLoad
            ? _c("img", {
                ref: "image",
                staticStyle: { display: "none" },
                attrs: { "fake-src": _vm.src },
                on: {
                  load: function ($event) {
                    return _vm.imageLoadHandler()
                  },
                },
              })
            : _c("img", {
                ref: "image",
                staticStyle: { display: "none" },
                attrs: { src: _vm.src },
                on: {
                  load: function ($event) {
                    return _vm.imageLoadHandler()
                  },
                },
              }),
          _vm._v(" "),
          _c("div", {
            ref: "bg-image",
            staticClass: "bg-image bg-image-high",
            style: { opacity: _vm.opacity },
          }),
          _vm._v(" "),
          _vm.overlay
            ? _c("div", {
                staticClass: "overlay",
                style: { backgroundColor: _vm.overlay },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pattern
            ? _c("div", {
                staticClass: "pattern",
                style: { backgroundImage: "url(" + _vm.pattern + ")" },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }